import { isNil } from 'lodash'
import { z } from 'zod'

import { GamSetupOrderSlice } from 'features/globalSetup/pages/GoogleAdManagerConnectionPage/sections/SetupPrebidStackSection/hooks/useGetGamSetupOrders'
import { MAX_SAFE_GQL_INTEGER } from 'providers/graphql/constants'
import { DEFAULT_INSTREAM_DURATION, DEFAULT_VAST_URL } from './constants'

export const schema = z.object({
  duration: z.number().step(1).min(1).max(MAX_SAFE_GQL_INTEGER),
  jsdelivrEnabled: z.boolean(),
  vastUrl: z.string(),
})

export type Schema = z.infer<typeof schema>

export const schemaDefault = (gamSetupOrder?: GamSetupOrderSlice): Schema => {
  const { duration, jsdelivrEnabled, vastUrl } = gamSetupOrder ?? {}

  return {
    duration: isNil(duration) ? DEFAULT_INSTREAM_DURATION : duration,
    jsdelivrEnabled: isNil(jsdelivrEnabled) ? true : jsdelivrEnabled,
    vastUrl: isNil(vastUrl) ? DEFAULT_VAST_URL : vastUrl,
  }
}
